import React from 'react';
import { Modal } from 'antd';

const ViewSizeGuide = (props) => {
  return (
    <>
      <Modal
        visible={props.visible}
        className={'primaryModal'}
        footer={false}
        onCancel={props.onCancel}
        width={800}
      >
        <div className='align-center '>
          <img
            src={props.size_guide_image ? props.size_guide_image : require("../assets/images/size-guide.jpg")}
            alt="size guide"
          />
        </div>
      </Modal>
    </>
  );
}

export default ViewSizeGuide;
